module.exports = window["MaterialUI"].ExpansionPanelDetails;